// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"c14ab095","623":"55c64972","769":"b1a7cc83","905":"30c12f9e"}[chunkId] + ".chunk.js";
};